﻿/*
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2025-12-19 11:30:42
 * @LastEditors: hongye
 * @LastEditTime: 2026-01-14 14:31:53
 * @Description: file content
 */
import { defineStore } from 'pinia'
import LangType from '@jms/utils/enums/LangType'
 type Lang = keyof typeof LangType

// 1. 获取环境变量(国家语言配置)
const defaultLocale = import.meta.env.VITE_DEFAULT_LOCALE;
// 2. 校验是否为合法的 LangType，如果配置错了（比如配成了 'fr'），回退到 'zh'
const isValidLocale = Object.values(LangType).includes(defaultLocale as any) || ['zh', 'hk', 'en', 'my', 'id'].includes(defaultLocale);

export const useSettingStore = defineStore('sysSetting', {
  state: () => ({
    collapsed: false,
    openKeys: [] as number[],
    selectedKeys: [] as number[],
    // 优先读取环境变量，其次是浏览器语言，最后默认为 zh
    locale: (isValidLocale ? defaultLocale : 'zh') as Lang,
    /**缈昏瘧鏁版嵁json */
    langJson: {} as Record<string, any>,
    station: {
      print: '',
      printer: '',
      template: 1,
      language: 'CN',
      isShowLogo: true
    } as Record<string, any>,
    lodopStatus: false as boolean,
    pendingCountData: [] as string[],
    printerList: [] as Record<string, any>[]
  }),
  getters: {
    getCollapsed: (state) => state.collapsed,
    getOpenKeys: (state) => state.openKeys,
    getSelectedKeys: (state) => state.selectedKeys,
    getStation: (state) => state.station
  },
  actions: {
    toggleCollapsed() {
      this.collapsed = !this.collapsed
    },
    setOpenkeys(keys: number[]) {
      if (this.openKeys.length) return
      this.openKeys = keys
    },
    setSelectedKeys(keys: number[]) {
      this.selectedKeys = keys
    }
  },
  persist: {
    storage: localStorage,
    paths: ['collapsed', 'locale', 'langJson', 'station', 'printerList']
  }
})
